module.exports = __webpack_public_path__ + "b57c725d7a606012f712bbfe130f0aba.jpg";